import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { R300 } from '@atlaskit/theme/colors';
import { hideControlsClassName } from '../classNames';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var VolumeWrapper = styled.div({
  display: 'flex',
  width: '35px',
  overflow: 'hidden',
  transition: 'width 0.3s',
  alignItems: 'center',
  bottom: "var(--ds-space-0, 0px)",
  left: "var(--ds-space-500, 40px)"
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.showSlider ? "\n    &:hover,\n    &:active,\n\t&:focus-within\n    {\n      width: 150px;\n      transition: width 0.3s ease-out;\n    }\n  " : '';
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CurrentTime = styled.div({
  color: '#c7d1db',
  userSelect: 'none',
  marginRight: "var(--ds-space-100, 8px)",
  whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TimeLine = styled.div({
  width: '100%',
  height: '2px',
  transitionDelay: '1s',
  transition: 'all 0.1s',
  backgroundColor: '#596773',
  borderRadius: '5px',
  position: 'relative'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CurrentTimeLine = styled.div({
  backgroundColor: '#05c',
  borderRadius: 'inherit',
  height: 'inherit',
  position: 'absolute',
  top: "var(--ds-space-0, 0px)",
  maxWidth: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Thumb = styled.div({
  pointerEvents: 'none',
  width: '14px',
  height: '14px',
  borderRadius: '100%',
  backgroundColor: 'white',
  border: '1px solid #666',
  position: 'absolute',
  right: 0,
  top: "var(--ds-space-025, 2px)",
  transform: 'translate(7px, -50%) scale(0)',
  transition: 'all 0.1s',
  transitionDelay: '1s',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:hover .current-time-tooltip': {
    opacity: 1
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CurrentTimeLineThumb = styled.div({
  position: 'absolute',
  display: 'block',
  right: '0',
  top: '50%',
  transform: 'translate(50%, -50%)',
  backgroundColor: '#05c',
  border: 'none',
  height: "var(--ds-space-150, 13px)",
  width: "var(--ds-space-150, 13px)",
  pointerEvents: 'none',
  borderRadius: '100%',
  opacity: '0',
  outline: "2px solid ".concat("var(--ds-border-focused, #85B8FF)"),
  outlineOffset: "var(--ds-space-025, 2px)",
  '&:focus': {
    opacity: '1'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:hover .current-time-tooltip': {
    opacity: 1
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:focus .current-time-tooltip': {
    opacity: 1
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var BufferedTime = styled.div({
  backgroundColor: '#8696a7',
  height: 'inherit',
  borderRadius: 'inherit',
  width: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LeftControls = styled.div({
  display: 'flex',
  marginLeft: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RightControls = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginRight: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ControlsWrapper = styled.div(_defineProperty({
  bottom: 0,
  left: 0,
  width: '100%',
  height: 'auto',
  background: 'linear-gradient(to top, #101214, rgba(14, 22, 36, 0))',
  position: 'absolute'
}, ":focus-within.".concat(hideControlsClassName), {
  opacity: '1'
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var VolumeToggleWrapper = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref) {
  var isMuted = _ref.isMuted;
  return "\n  position: relative;\n  margin-right: 13px;\n  button {\n    width: 36px !important;\n    color: ".concat(isMuted ? '#EF5C48 !important;' : '', "\n  }");
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var VolumeTimeRangeWrapper = styled.div({
  width: '100%',
  marginRight: "var(--ds-space-250, 20px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MutedIndicator = styled.div({
  width: '29px',
  height: '2px',
  position: 'absolute',
  top: "var(--ds-space-100, 8px)",
  left: "var(--ds-space-100, 8px)",
  zIndex: 2,
  background: R300,
  transform: 'rotate(32deg) translateY(10px)',
  opacity: 0,
  pointerEvents: 'none'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isMuted ? "\n    opacity: 1;\n  " : '';
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CurrentTimeTooltip = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref2) {
  var isDragging = _ref2.isDragging;
  return "\n  position: absolute;\n  user-select: none;\n  top: ".concat("var(--ds-space-negative-400, -32px)", ";\n  background-color: #182c4c;\n  color: #eff1f3;\n  font-size: ", "var(--ds-space-150, 12px)", ";\n  padding: ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-100, 8px)", ";\n  border-radius: ", "var(--ds-space-050, 4px)", ";\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: ", isDragging ? '1' : '0', ";\n  transition: opacity 0.3s;\n  word-break: keep-all;\n");
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TimeRangeWrapper = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref3) {
  var showAsActive = _ref3.showAsActive;
  return "\n  display: flex;\n  align-items: center;\n  height: 22px;\n\n  cursor: pointer;\n  width: 100%;\n\n  &:hover ".concat(TimeLine, " {\n    height: 4px;\n    transition: all 0.1s;\n  }\n\n  &:hover ").concat(Thumb, " {\n    transition: all 0.1s;\n    transform: translate(7px, -50%) scale(1);\n  }\n\n  ").concat(TimeLine, " {\n    transition-delay: 1s;\n    ").concat(showAsActive ? 'height: 4px;' : '', "\n  }\n  ").concat(Thumb, " {\n    ").concat(showAsActive ? 'transform: translate(7px, -50%) scale(1);' : '', "\n  }\n\n  ", "\n    // a11y override default theme colors from '@atlaskit/range' to have better contrast with panel color\n    input[type=\"range\"] {\n      width:100%;\n      cursor: pointer;\n      height: 14px;\n    }\n\n    input[type=\"range\"]::-webkit-slider-thumb {\n      -webkit-appearance: none; /* Override default look */\n      appearance: none;\n      background: #9FADBC;\n      width: 14px;\n      height: 14px;\n      margin-top: -5px; // smaller thumb requires adjustment for margin\n    }\n\n    input[type=\"range\"]::-webkit-slider-runnable-track {\n      --webkit-appearance: none; /* Override default look */\n      --track-bg: #596773;\n      --track-fg: #9FADBC;\n    }\n\n    input[type=\"range\"]::-moz-range-progress {\n      background-color: #9FADBC;\n    }\n\n    input[type=\"range\"]::-moz-range-track {\n      background-color: #596773;\n    }\n\n    input[type=\"range\"]::-moz-range-thumb {\n      background: #9FADBC;\n      width: 14px;\n      height: 14px;\n    }\n    ", "\n");
});